/**
 * EMETLAssessmentSearchHeader
 * © EMETL Working Group
 * 
 * @author  Andrew Berger
 * @version 1.0.0
 */

import React, {
    useContext,
} from "react"

import {
    useNavigate,
} from "react-router-dom"

import {
    Context,
} from "../../../../Model/Contexts/AppContext"
import EMETLSearchBar from "../../EMETLSearchBar"

export type SearchHeaderProps = {
    placeholder?: string,
    attributes?: string[],
}

/**
 * This component will represent the search header content container. It is the default header content.
 *
 * @since 1.0.0
 * @default
 * @exports SearchHeader
 * @class
 */
const EMETLAssessmentSearchHeader = (props: SearchHeaderProps) => {
    const {
        placeholder = "Search Assessment Data",
        attributes = [
            "Title",
            "Tasks",
            "Assessor",
        ],
    } = props

    const {
        assessmentData: {
            assessments,
        },
    } = useContext(Context)

    const navigate = useNavigate()

    return (
        <EMETLSearchBar 
            options={attributes}
            select={assessment => {
                navigate("/Assessment", {
                    state: {
                        assessment,
                    }
                })
            }}
            placeholder={placeholder} 
            haystack={assessments?.value} 
            name={attributes[0]}
            attribute={attributes[0]}
        />
    )
}

export default EMETLAssessmentSearchHeader